/*
 * Camada HTTP da tela personalizada "Perguntar aos Dados".
 * Rotas POST /Personalizado/PerguntarDados/*  (regra Babita: chamadas so por aqui).
 * Envia sempre `solicitante` (email do usuario logado, ou CPF/CNPJ da revendedora) no
 * corpo — e assim que o backend resolve setor/nivel/permissao (nao ha sessao).
 */
const BASE = (process.env.REACT_APP_API_URL || `${process.env.REACT_APP_SERVER_IP || 'http://192.168.0.204'}:${process.env.REACT_APP_SERVER_PORT || '3010'}`).replace(/\/+$/, '');

// Identidade EXTERNA (revendedora): a tela /revendedora loga por CPF/CNPJ+senha (sem sessao
// no backend -- cada chamada precisa da senha de novo). Guardar aqui evita ter que passar
// `senha` manualmente pelos ~30 pontos de chamada deste componente (nenhum deles conhece
// "senha" hoje) -- basta chamar definirSenhaExterna() uma vez apos o login validar.
let _senhaExterna = null;
export function definirSenhaExterna(senha) { _senhaExterna = senha || null; }
export function limparSenhaExterna() { _senhaExterna = null; }

async function post(path, body) {
    const corpo = { ...(body || {}) };
    if (_senhaExterna && corpo.solicitante != null && corpo.senha == null) corpo.senha = _senhaExterna;
    try {
        const resp = await fetch(`${BASE}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(corpo),
        });
        const ct = resp.headers.get('content-type') || '';
        if (ct.includes('application/json')) {
            const j = await resp.json();
            if (!resp.ok && !j.Error) j.Error = `HTTP ${resp.status}`;
            return j;
        }
        const txt = await resp.text().catch(() => '');
        if (!resp.ok) return { Error: `HTTP ${resp.status}${txt ? ': ' + txt.slice(0, 200) : ''}` };
        return { raw: txt };
    } catch (e) {
        return { Error: e.message || 'Falha de rede.' };
    }
}

const P = '/Personalizado/PerguntarDados';

// Usuario comum
export const Contexto = (b) => post(`${P}/Contexto`, b);  // contexto leve (setor/nivel/ti) p/ abas
export const Sugerir  = (b) => post(`${P}/Sugerir`, b);   // autocomplete enquanto digita
export const Buscar   = (b) => post(`${P}/Buscar`, b);    // agora devolve params_sugeridos no topo
export const Executar = (b) => post(`${P}/Executar`, b);
export const Explorar = (b) => post(`${P}/Explorar`, b);   // busca guiada por facetas (chips)
export const Alertas  = (b) => post(`${P}/Alertas`, b);    // destaques do dia (semaforo)

// Alto uso / colaboracao
export const MaisPerguntadas = (b) => post(`${P}/MaisPerguntadas`, b);  // {solicitante,setor?,k}
export const Compartilhar    = (b) => post(`${P}/Compartilhar`, b);     // {solicitante,id,params} -> {hash}
export const Compartilhado   = (b) => post(`${P}/Compartilhado`, b);    // {hash} -> snapshot
export const Fixar           = (b) => post(`${P}/Fixar`, b);            // {solicitante,id,fixar}
export const ListaFixadas    = (b) => post(`${P}/ListaFixadas`, b);     // {solicitante}

// Conveniencia: sugerir(q, setor) monta o corpo (solicitante e injetado pelo componente).
// Assinatura pedida na task; reaproveita Sugerir acima.
export const sugerir = (solicitante, q, setor) =>
    Sugerir({ solicitante, q, setor: setor || undefined });

// Painel Metas x Realizado x Semaforo (backend faz o guard: Diretoria/TI)
// aceita filtro de periodo {inicio,fim} (AAAA-MM-DD); default backend = ano fiscal -> hoje.
export const Metas  = (b) => post(`${P}/Metas`, b);
// Conveniencia pedida na task: metas(solicitante, {inicio,fim}) monta o corpo.
export const metas  = (solicitante, periodo) =>
    Metas({ solicitante, inicio: periodo?.inicio, fim: periodo?.fim });

// Painel TI (o backend faz o guard; so aparece se contexto.ti === true)
export const TIListaCatalogo   = (b) => post(`${P}/TIListaCatalogo`, b);
export const TISalvaPermissao  = (b) => post(`${P}/TISalvaPermissao`, b);
export const TIListaAprendizado = (b) => post(`${P}/TIListaAprendizado`, b);

// Construtor de Q&A da TI (F8) — popular a base com guarda anti-peso (guard TI no backend)
export const TIInbox       = (b) => post(`${P}/TIInbox`, b);        // {solicitante} -> candidatos (demanda real)
export const TIProporQA    = (b) => post(`${P}/TIProporQA`, b);     // NAO grava: dedup + preview + medidor
export const TIPublicarQA  = (b) => post(`${P}/TIPublicarQA`, b);   // escrita atomica + bump versao + reindex
export const TIMedidorPeso = (b) => post(`${P}/TIMedidorPeso`, b);  // {itens,frases_total,bytes,vetores,versao}

// ── Publico (SEM login) — landing unificada /perguntar (modo "Explorar"). O backend NAO
// exige sessao nestas rotas e ja poda o que e sensivel (PublicoProduto NUNCA devolve preco,
// estoque ou numero comercial). Mantem a regra Babita: todo HTTP passa por aqui.
export const PublicoProduto  = (b) => post(`${P}/PublicoProduto`, b);   // {q, codigo?} -> {produtos:[...]}
export const PublicoHistoria = (b) => post(`${P}/PublicoHistoria`, b);  // {} -> {itens:[{titulo,texto,fonte}]}
// PublicoGuia e um GET que faz stream de PDF -> abrir em nova aba / iframe. Devolve a URL pronta.
export const PublicoGuiaUrl  = (nome) => `${BASE}${P}/PublicoGuia?nome=${encodeURIComponent(nome)}`;

// Tutoriais em video + manual escrito (pagina /tutoriais). EXIGE login do Central (ordem do diretor, 26/10/2026): o manifesto so
// responde para `solicitante` de usuario ativo e entrega um TOKEN de acesso por tutorial; os arquivos (video, capa, imagens) levam o
// token na URL (?t=) porque o <video> e o <img> nao mandam cabecalho. Sem login o servidor devolve 401 { precisaLogin: true }.
// Fetch proprio (o post() acima reenvia a senha da revendedora quando ha `solicitante` — aqui nao ha senha).
//   PublicoTutoriais({ solicitante }) -> manifesto { atualizado, grupos: [...], acessos, acessoValidoAte } (relido do disco a cada pedido)
//   PublicoTutorialUrl  -> URL de um arquivo do manifesto (mp4/jpg/png/webp) com suporte a Range, ja com o token do tutorial;
//                          opc.tutorial = id do tutorial que mostra o arquivo (senao vale a primeira pasta do caminho);
//                          opc.baixar forca download, opc.nome sugere o nome do arquivo baixado.
let _acessosTutoriais = {};
export function definirAcessosTutoriais(mapa) {
    _acessosTutoriais = mapa && typeof mapa === 'object' && !Array.isArray(mapa) ? { ...mapa } : {};
}
export async function PublicoTutoriais({ solicitante } = {}) {
    try {
        const resp = await fetch(`${BASE}${P}/PublicoTutoriais`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ solicitante: solicitante || '' }),
        });
        const ct = resp.headers.get('content-type') || '';
        if (!ct.includes('application/json')) return { Error: `HTTP ${resp.status}` };
        const j = await resp.json();
        if (resp.status === 401) { definirAcessosTutoriais(null); return { ...j, precisaLogin: true }; }
        if (!resp.ok && !j.Error) j.Error = `HTTP ${resp.status}`;
        if (resp.ok) definirAcessosTutoriais(j.acessos);
        return j;
    } catch (e) {
        return { Error: e.message || 'Falha de rede.' };
    }
}
export const PublicoTutorialUrl = (arquivo, opc) => {
    const partes = String(arquivo || '').split('/');
    let url = `${BASE}${P}/PublicoTutorialArquivo?arquivo=${partes.map(encodeURIComponent).join('/')}`;
    if (opc && opc.baixar) url += '&baixar=1';
    if (opc && opc.nome) url += `&nome=${encodeURIComponent(opc.nome)}`;
    const token = (opc && opc.tutorial && _acessosTutoriais[opc.tutorial]) || _acessosTutoriais[partes[0]];
    if (token) url += `&t=${encodeURIComponent(token)}`;
    return url;
};

// Acompanhamento dos tutoriais (pagina /tutoriais, so com login). O instantaneo da visita vai para PublicoTutorialEvento como TEXTO
// (text/plain: o que o navigator.sendBeacon manda e o que dispensa preflight de CORS) — ver components/Tutoriais/rastreador.js.
export const PublicoTutorialEventoUrl = () => `${BASE}${P}/PublicoTutorialEvento`;
// Selo "Visto": os ids dos tutoriais que a pessoa (login conferido no servidor) ja concluiu.
// Qualquer falha devolve [] — a lista de tutoriais funciona do mesmo jeito sem o selo.
export async function PublicoTutorialVistos({ visitante, solicitante }) {
    try {
        const corpo = { v: 1, visitante };
        if (solicitante) corpo.solicitante = solicitante;
        const resp = await fetch(`${BASE}${P}/PublicoTutorialProgresso`, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify(corpo),
        });
        const ct = resp.headers.get('content-type') || '';
        if (!resp.ok || !ct.includes('application/json')) return [];
        const j = await resp.json();
        return j && Array.isArray(j.vistos) ? j.vistos.filter((x) => typeof x === 'string') : [];
    } catch (e) {
        return [];
    }
}

export const apiBase = BASE;

// ── Cockpit do Diretor ─────────────────────────────────────────────────────
// Panorama executivo pronto: { ok, janela{inicio,fim,rotulo}, kpis[], graficos[], dicas[], proveniencia }.
// O backend faz o guard (so Diretoria/TI; qualquer outro -> { erro:'restrito' } sem vazar numero).
// periodo: 'diario' | 'semanal' | 'mensal' (default mensal). `solicitante` e injetado pelo componente.
export const PanoramaDiretor = (b) =>
    post(`${P}/PanoramaDiretor`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, periodo: b?.periodo, preset: b?.preset });

// Comparacao de lancamentos do cockpit (sexta a quarta, ultimos 8 + atual, e o mesmo lancamento
// do ano passado). RBAC no backend (Diretoria/TI). `solicitante` injetado pelo componente.
export const LancamentosComparados = (b) => post(`${P}/LancamentosComparados`, { solicitante: b?.solicitante, forcar: !!b?.forcar, loja: b?.loja, vendedora: b?.vendedora, universo: b?.universo });
// abas Revistas / Fornecedor (Diretoria/TI): lancamento = revista regular + irma PLUS; leitura ao vivo no bd_think
export const RevistasLancamentos = (b) => post(`${P}/RevistasLancamentos`, { solicitante: b?.solicitante, forcar: !!b?.forcar, universo: b?.universo });
export const RevistaResumo = (b) => post(`${P}/RevistaResumo`, { solicitante: b?.solicitante, grupo: b?.grupo, inicio: b?.inicio, fim: b?.fim, segmento: b?.segmento, universo: b?.universo });
export const FornecedorAnalise = (b) => post(`${P}/FornecedorAnalise`, { solicitante: b?.solicitante, grupo: b?.grupo, marca: b?.marca, inicio: b?.inicio, fim: b?.fim });
export const RevistaCompartilhar = (b) => post(`${P}/RevistaCompartilhar`, { solicitante: b?.solicitante, tipo: b?.tipo, grupo: b?.grupo, marca: b?.marca, inicio: b?.inicio, fim: b?.fim, segmento: b?.segmento, base: b?.base , universo: b?.universo });
// Card de estoque e reposicao da aba Essencial: escaninho por produto x tamanho + pedidos sugeridos.
// (a regra vem de bd_babitacentral.essrep_regra; a espinha da consulta e o cadastro, nao o estoque)
export const EssencialReposicao = (b) => post(`${P}/EssencialReposicao`, { solicitante: b?.solicitante, revs: b?.revs, porCor: b?.porCor });
// Solicitacao de reposicao ao fornecedor (Essencial). ⚠️ As UNICAS chamadas do Cockpit que ESCREVEM.
// Nada sai da casa por aqui: grava o pedido e devolve a lista; o envio ao fornecedor e manual.
export const EssencialSolicitar = (b) => post(`${P}/EssencialSolicitar`, { solicitante: b?.solicitante, marca: b?.marca, revs: b?.revs, itens: b?.itens, observacao: b?.observacao, codigo_fornecedor: b?.codigo_fornecedor });
// lista enxuta das edicoes do Essencial (sem venda) - usada pela tela da Logistica
export const EssencialEdicoes = (b) => post(`${P}/EssencialEdicoes`, { solicitante: b?.solicitante });
export const EssencialSolicitacoes = (b) => post(`${P}/EssencialSolicitacoes`, { solicitante: b?.solicitante, revs: b?.revs, status: b?.status });
export const EssencialSolicitacaoStatus = (b) => post(`${P}/EssencialSolicitacaoStatus`, { solicitante: b?.solicitante, id: b?.id, status: b?.status });
// Corrige uma solicitacao que ainda esta ABERTA: a lista de itens e trocada inteira pela que vai
// aqui (o backend apaga e regrava). Marca, revistas e o numero da solicitacao NAO mudam.
export const EssencialSolicitacaoAtualizar = (b) => post(`${P}/EssencialSolicitacaoAtualizar`, { solicitante: b?.solicitante, id: b?.id, itens: b?.itens, observacao: b?.observacao, codigo_fornecedor: b?.codigo_fornecedor });
// Cockpit: eventos do mes atual e do proximo no Calendario Babita (calmkt_*, bd_babitacentral)
export const CalendarioProximo = (b) => post(`${P}/CalendarioProximo`, { solicitante: b?.solicitante });
// aba Vendedoras (Diretoria/TI): venda por empresa / loja / vendedora, com meta, mix, ticket e troca
export const VendedorasResumo = (b) => post(`${P}/VendedorasResumo`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, loja: b?.loja, vendedora: b?.vendedora, comGerentes: !!b?.comGerentes });
export const VendedorasProdutos = (b) => post(`${P}/VendedorasProdutos`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, loja: b?.loja, vendedora: b?.vendedora, comGerentes: !!b?.comGerentes });
// Liga mes a mes: entraram x sairam e quantas na Liga no fim do mes (12 meses), Babita / loja / carteira da vendedora
export const LigaMovimento = (b) => post(`${P}/LigaMovimento`, { solicitante: b?.solicitante, vendedora: b?.vendedora, loja: b?.loja });
// aba Liga do Cockpit: arrecadacao da mensalidade, beneficios, programas, estrelas, ranking e saidas
export const LigaPainel = (b) => post(`${P}/LigaPainel`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim });
export const LigaResumo = (b) => post(`${P}/LigaResumo`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, loja: b?.loja, vendedora: b?.vendedora, comGerentes: !!b?.comGerentes });
// ⚠️ campo que nao estiver declarado aqui e DESCARTADO calado (o corpo e montado campo a campo)
export const ChequeResumo = (b) => post(`${P}/ChequeResumo`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, loja: b?.loja, vendedora: b?.vendedora });
export const VendedorasCompartilhar = (b) => post(`${P}/VendedorasCompartilhar`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, loja: b?.loja, vendedora: b?.vendedora, comGerentes: !!b?.comGerentes });
// aba RMF: a materia-prima do Ritual Mensal de Fornecedores (o rascunho do deck)
export const RMFResumo = (b) => post(`${P}/RMFResumo`, { solicitante: b?.solicitante, corte: b?.corte, lancamentos: b?.lancamentos });
export const RMFCompartilhar = (b) => post(`${P}/RMFCompartilhar`, { solicitante: b?.solicitante, corte: b?.corte, lancamentos: b?.lancamentos });
// aba Verificacoes: renovacao de troca (tabela do cron) + nota duplicada (refeita ao vivo)
export const VerificacoesLojas = (b) => post(`${P}/VerificacoesLojas`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, dias: b?.dias });
// aba Viagem Merecida (Diretoria/TI): campanha de bilhetes out/2026-fev/2027 -- desafio, ranking, sorteio (sem simulacao desde 01/10/2026)
export const ViagemMerecidaResumo = (b) => post(`${P}/ViagemMerecidaResumo`, { solicitante: b?.solicitante });
export const ViagemMerecidaSorteioCriar = (b) => post(`${P}/ViagemMerecidaSorteioCriar`, { solicitante: b?.solicitante, publico: b?.publico });
// Trocas fora do padrao (regra da linha + janela dos 7 dias) e conversao da troca em venda por vendedora
export const TrocasPadraoLancamento = (b) => post(`${P}/TrocasPadraoLancamento`, { solicitante: b?.solicitante, grupo: b?.grupo, universo: b?.universo });
export const TrocasPadraoGeral = (b) => post(`${P}/TrocasPadraoGeral`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim });
export const TrocasConversaoVendedoras = (b) => post(`${P}/TrocasConversaoVendedoras`, { solicitante: b?.solicitante, inicio: b?.inicio, fim: b?.fim, loja: b?.loja, vendedora: b?.vendedora, comGerentes: !!b?.comGerentes });

// ── Config do relatorio diario do Cockpit do Diretor (engrenagem no cockpit) ──
// RBAC no backend (so Diretoria/TI; outro -> { erro:'restrito' }). `solicitante` injetado pelo componente.
export const DiretorConfigLer    = (b) => post(`${P}/DiretorConfigLer`, b);     // {solicitante} -> {ok, config}
export const DiretorConfigSalvar = (b) => post(`${P}/DiretorConfigSalvar`, b);  // {solicitante, config:{...}} -> {ok, salvo, config}
